import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=3b59c892&scoped=true"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/review_rating/review_content.css?vue&type=style&index=0&id=3b59c892&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b59c892",
  null
  
)

export default component.exports